var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ChangeDetectionStrategy, Component, ViewChild } from '@angular/core';
import { ColumnBaseComponent } from '../base/columnbase.component';
import { ColumnService } from '../column/column.service';
import { ColumnBaseService } from '../base/columnbase.service';
var DateTimeComponent = /** @class */ (function (_super) {
    __extends(DateTimeComponent, _super);
    function DateTimeComponent(service, baseService) {
        var _this = _super.call(this, service, baseService) || this;
        _this.service = service;
        _this.baseService = baseService;
        _this.typeOptions = {
            date: {
                scrollInput: false,
                datepicker: true,
                timepicker: false,
                format: 'yyyy/MM/dd',
                formatDate: 'yyyy/MM/dd'
            },
            time: {
                scrollInput: false,
                datepicker: false,
                timepicker: true,
                format: 'HH:mm',
                formatTime: 'HH:mm'
            },
            datetime: {
                scrollInput: false,
                datepicker: true,
                timepicker: true,
                format: 'yyyy/MM/dd HH:mm',
                formatDate: 'yyyy/MM/dd',
                formatTime: 'HH:mm'
            }
        };
        _this.defOptions = {};
        _this.locale = '';
        _this.show = false;
        _this.select = false;
        _this.newVal = '';
        return _this;
    }
    DateTimeComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
    };
    DateTimeComponent.prototype.ngOnChanges = function (changes) {
        _super.prototype.ngOnChanges.call(this, changes);
        if (changes.msg) {
            this.setDefOptions(this.col.controlType);
            this.setFormatter();
        }
    };
    DateTimeComponent.prototype.ngAfterViewInit = function () {
        this.element = this.datetimeElement.nativeElement;
    };
    DateTimeComponent.prototype.setFormatter = function () {
        $.datetimepicker.setLocale(this.locale);
        $.datetimepicker.setDateFormatter({
            parseDate: function (date, format) {
                var f = moment().toMomentFormatString(format);
                var d = moment(date, f);
                return d.isValid() ? d.toDate() : false;
            },
            formatDate: function (date, format) {
                return moment(date).formatWithJDF(format);
            }
        });
    };
    DateTimeComponent.prototype.setDateTimePicker = function () {
        var _this = this;
        var self = this;
        var type = this.col.controlType;
        var range = (this.col.params && this.col.params.range ? this.col.params.range : {});
        var from = range.from;
        var to = range.to;
        if (from && to) {
            from = this.baseService.getColKey(this.componentName, from, this.index);
            to = this.baseService.getColKey(this.componentName, to, this.index);
            // 開始日
            if (this.colKey === from) {
                var addOptions = {};
                var toVal_1 = $('input[name="' + to + '"]').val();
                var maxVal = toVal_1 ? toVal_1 : false;
                if (type === 'time') {
                    addOptions['maxTime'] = maxVal;
                }
                else {
                    addOptions['maxDate'] = maxVal;
                }
                $(this.element).datetimepicker(Object.assign({}, this.defOptions, addOptions, {
                    onGenerate: function (ct, $i) {
                        var val = toVal_1 ? toVal_1 : '';
                        if ((type === 'datetime' || type === 'time') && val) {
                            self.setTime(this, ct, null, val);
                        }
                    },
                    onChangeDateTime: function (ct, $i) {
                        self.select = true;
                        _super.prototype.onChange.call(_this, $i.val());
                    },
                    onSelectTime: function (ct, $i) {
                        self.show = false;
                    },
                    onClose: function (ct, $i) {
                        self.onClose(ct, $i);
                    }
                }));
            }
            // 終了日
            if (this.colKey === to) {
                var addOptions = {};
                var fromVal_1 = $('input[name="' + from + '"]').val();
                var minVal = fromVal_1 ? fromVal_1 : false;
                if (type === 'time') {
                    addOptions['minTime'] = minVal;
                }
                else {
                    addOptions['minDate'] = minVal;
                }
                $(this.element).datetimepicker(Object.assign({}, this.defOptions, addOptions, {
                    onGenerate: function (ct, $i) {
                        var val = fromVal_1 ? fromVal_1 : '';
                        if ((type === 'datetime' || type === 'time') && val) {
                            self.setTime(this, ct, val, null);
                        }
                    },
                    onChangeDateTime: function (ct, $i) {
                        self.select = true;
                        _super.prototype.onChange.call(_this, $i.val());
                    },
                    onSelectTime: function (ct, $i) {
                        self.show = false;
                    },
                    onClose: function (ct, $i) {
                        self.onClose(ct, $i);
                    }
                }));
            }
        }
        else {
            $(this.element).datetimepicker(Object.assign({}, this.defOptions, {
                onGenerate: function (ct, $i) {
                    if (type === 'datetime' && self.options) {
                        var max = self.options['maxDate'];
                        var min = self.options['minDate'];
                        self.setTime(this, ct, min, max);
                    }
                    else if (type === 'time' && self.options) {
                        var max = self.options['maxTime'];
                        var min = self.options['minTime'];
                        self.setTime(this, ct, min, max);
                    }
                },
                onChangeDateTime: function (ct, $i) {
                    self.select = true;
                    _super.prototype.onChange.call(_this, $i.val());
                },
                onSelectTime: function (ct, $i) {
                    self.show = false;
                },
                onClose: function (ct, $i) {
                    self.onClose(ct, $i);
                }
            }));
        }
    };
    DateTimeComponent.prototype.setTime = function (element, ct, min, max) {
        var minDatetime = moment(min, moment().toMomentFormatString(this.defOptions['format']));
        var maxDatetime = moment(max, moment().toMomentFormatString(this.defOptions['format']));
        if ((minDatetime.isValid() && ct.getFullYear() === minDatetime.get('year') && ct.getMonth() === minDatetime.get('month') && ct.getDate() === minDatetime.get('date'))
            || (maxDatetime.isValid() && ct.getFullYear() === maxDatetime.get('year') && ct.getMonth() === maxDatetime.get('month') && ct.getDate() === maxDatetime.get('date'))) {
            var minTime_1 = minDatetime.isValid() ? new Date(minDatetime).getTime() : null;
            var maxTime_1 = maxDatetime.isValid() ? new Date(maxDatetime).getTime() : null;
            $(element).find('.xdsoft_time').map(function () {
                ct.setHours($(this).data('hour'));
                ct.setMinutes($(this).data('minute'));
                ct.setSeconds(0);
                ct.setMilliseconds(0);
                if ((minTime_1 && minTime_1 > ct.getTime()) || (maxTime_1 && maxTime_1 < ct.getTime())) {
                    return $(this).addClass('xdsoft_disabled');
                }
                else {
                    return $(this).removeClass('xdsoft_disabled');
                }
            });
        }
    };
    DateTimeComponent.prototype.setDefOptions = function (type) {
        this.options = (this.col.params && this.col.params.options ? this.col.params.options : {});
        this.locale = this.msg['au.COMPONENT.DateTimeComponent.option.locale'] || 'en';
        var format = this.msg['au.COMPONENT.DateTimeComponent.option.format'];
        var formatDate = this.msg['au.COMPONENT.DateTimeComponent.option.formatDate'];
        var formatTime = this.msg['au.COMPONENT.DateTimeComponent.option.formatTime'];
        var dayOfWeekStart = this.msg['au.COMPONENT.DateTimeComponent.option.dayOfWeekStart'] || 'sunday';
        var week = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
        var options = {
            i18n: {},
            dayOfWeekStart: week.indexOf(dayOfWeekStart) >= 0 ? week.indexOf(dayOfWeekStart) : 0,
        };
        var opt = this.typeOptions[type];
        if (type === 'date') {
            options['format'] = formatDate || opt.format;
            options['formatDate'] = formatDate || opt.formatDate;
        }
        else if (type === 'time') {
            options['format'] = formatTime || opt.format;
            options['formatTime'] = formatTime || opt.formatTime;
        }
        else {
            options['format'] = format || opt.format;
            options['formatDate'] = formatDate || opt.formatDate;
            options['formatTime'] = formatTime || opt.formatTime;
        }
        var sysOptions = $.fn.datetimepicker.defaults;
        if (sysOptions && sysOptions['i18n'] && !sysOptions['i18n'][this.locale]) {
            this.locale = 'en';
        }
        options['i18n'][this.locale] = {
            months: [
                this.msg['au.COMPONENT.DateTimeComponent.label.january'] || 'January',
                this.msg['au.COMPONENT.DateTimeComponent.label.february'] || 'February',
                this.msg['au.COMPONENT.DateTimeComponent.label.march'] || 'March',
                this.msg['au.COMPONENT.DateTimeComponent.label.april'] || 'April',
                this.msg['au.COMPONENT.DateTimeComponent.label.may'] || 'May',
                this.msg['au.COMPONENT.DateTimeComponent.label.june'] || 'June',
                this.msg['au.COMPONENT.DateTimeComponent.label.july'] || 'July',
                this.msg['au.COMPONENT.DateTimeComponent.label.august'] || 'August',
                this.msg['au.COMPONENT.DateTimeComponent.label.september'] || 'September',
                this.msg['au.COMPONENT.DateTimeComponent.label.october'] || 'October',
                this.msg['au.COMPONENT.DateTimeComponent.label.november'] || 'November',
                this.msg['au.COMPONENT.DateTimeComponent.label.december'] || 'December'
            ],
            dayOfWeekShort: [
                this.msg['au.COMPONENT.DateTimeComponent.label.sunday'] || 'Sun',
                this.msg['au.COMPONENT.DateTimeComponent.label.monday'] || 'Mon',
                this.msg['au.COMPONENT.DateTimeComponent.label.tuesday'] || 'Tue',
                this.msg['au.COMPONENT.DateTimeComponent.label.wednesday'] || 'Wed',
                this.msg['au.COMPONENT.DateTimeComponent.label.thursday'] || 'Thu',
                this.msg['au.COMPONENT.DateTimeComponent.label.friday'] || 'Fri',
                this.msg['au.COMPONENT.DateTimeComponent.label.saturday'] || 'Sat'
            ]
        };
        this.defOptions = Object.assign({}, this.typeOptions[type], options, this.options);
    };
    DateTimeComponent.prototype.showDateTimePicker = function (e) {
        var selectionStart = e.target.selectionStart;
        var selectionEnd = e.target.selectionEnd;
        this.setDateTimePicker();
        $(this.element).datetimepicker('show');
        this.element.setSelectionRange(selectionStart, selectionEnd); // .datetimepicker('show')で.select()が実行されるので再設定する
        this.show = true;
    };
    DateTimeComponent.prototype.onKeyup = function (e) {
        if (e.keyCode === 9) { // 9: Tab
            this.showDateTimePicker(e);
        }
    };
    DateTimeComponent.prototype.onClick = function (e) {
        if (!this.show) {
            this.showDateTimePicker(e);
        }
        else {
            this.show = false;
        }
    };
    DateTimeComponent.prototype.onBlur = function (e) {
        this.show = false;
    };
    DateTimeComponent.prototype.onClose = function (ct, $i) {
        if (!this.select && ct && $i.val()) {
            var f = moment().toMomentFormatString(this.defOptions.format);
            var date = moment(ct).formatWithJDF(this.defOptions.format);
            if (!moment($i.val(), f, true).isValid() && $i.val() !== date) {
                this.newVal = date;
            }
        }
        $(this.element).datetimepicker('destroy');
        this.select = false;
    };
    DateTimeComponent.prototype.onChange = function (e, changeFlg) {
        if (changeFlg === void 0) { changeFlg = true; }
        if (this.newVal) {
            this.val = this.newVal;
            _super.prototype.onChange.call(this, this.val);
            this.newVal = '';
            return;
        }
        if (e) {
            var f = moment().toMomentFormatString(this.defOptions.format);
            if (!moment(e, f, true).isValid()) {
                this.val = moment().format(f);
                _super.prototype.onChange.call(this, this.val);
                return;
            }
        }
        _super.prototype.onChange.call(this, e, changeFlg);
    };
    DateTimeComponent.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
    };
    DateTimeComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'column-datetime',
                    template: '<input type="text" name="{{ colKey }}" attr.name="{{ colKey }}" [placeholder]="col" [(ngModel)]="val" (keyup)="onKeyup($event)" (click)="onClick($event)" (blur)="onBlur($event)" (change)="onChange(val)"  [key]="key" [col]="col" columnDir #datetime>',
                    changeDetection: ChangeDetectionStrategy.OnPush
                }] }
    ];
    /** @nocollapse */
    DateTimeComponent.ctorParameters = function () { return [
        { type: ColumnService },
        { type: ColumnBaseService }
    ]; };
    DateTimeComponent.propDecorators = {
        datetimeElement: [{ type: ViewChild, args: ['datetime',] }]
    };
    return DateTimeComponent;
}(ColumnBaseComponent));
export { DateTimeComponent };
//# sourceMappingURL=datetime.component.js.map